import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-md-6 col-xl-4 mb-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon-printer icon-2x" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Alle", -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "icon-printer icon-2x" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.headline), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary btn-block btn-float",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printOverview(null)))
        }, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("small", null, _toDisplayString(_ctx.headline) + " aller Objekte", 1)
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objects, (object, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "col-12 col-md-6 col-xl-4 mb-2"
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary btn-block btn-float",
            onClick: ($event: any) => (_ctx.printOverview(object.pid))
          }, [
            _hoisted_7,
            _createElementVNode("span", null, _toDisplayString(object.p_firma ? object.p_firma : object.p_vorname+" "+object.p_name), 1),
            _createElementVNode("small", null, [
              _createElementVNode("span", null, _toDisplayString(object.p_strasse) + " " + _toDisplayString(object.p_hnr) + " | " + _toDisplayString(object.p_plz) + " " + _toDisplayString(object.p_ort), 1)
            ])
          ], 8, _hoisted_6)
        ]))
      }), 128))
    ])
  ]))
}